import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FaLinkedinIn } from 'react-icons/fa'
import { FiCheck } from 'react-icons/fi'
import aiImg from '../../../assets/images/ai-avatar.svg'
import CenterModal from '../../molecules/Modal/CenterModal'
import ConnectAccountSteps from '../EmailAccoutDetail/ConnectAccountSteps'
import onboardingService from '../../../services/onboardingService'
import { StyledConnectLinkedIn } from './NewOnboarding.styles'

const ConnectLinkedIn = ({ onContinue }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isIframeOpen, setIsIframeOpen] = useState(false)
    const [connectedProfile, setConnectedProfile] = useState(null)
    const [disconnectedProfile, setDisconnectedProfile] = useState(null)
    const [hasProceeded, setHasProceeded] = useState(false)

    const loadConnectedProfile = useCallback(async () => {
        try {
            const res = await onboardingService.getConnectedLinkedinProfiles()
            const profiles = res?.data || []
            setConnectedProfile(profiles.find(profile => profile.gologinProfileId && profile.isLoggedIn === true) || null)
            setDisconnectedProfile(profiles.find(profile => profile.gologinProfileId && profile.isLoggedIn !== true) || null)
        } catch {
            setConnectedProfile(null)
            setDisconnectedProfile(null)
        }
    }, [])

    useEffect(() => {
        loadConnectedProfile()
    }, [loadConnectedProfile])

    const onContinueRef = useRef(onContinue)
    useEffect(() => {
        onContinueRef.current = onContinue
    })

    const hasContinuedRef = useRef(false)
    const proceed = useCallback(() => {
        if (hasContinuedRef.current) return
        hasContinuedRef.current = true
        setHasProceeded(true)
        onContinueRef.current?.()
    }, [])

    useEffect(() => {
        if (!connectedProfile) return undefined
        const timer = setTimeout(proceed, 1200)
        return () => clearTimeout(timer)
    }, [connectedProfile, proceed])

    const closeModal = () => {
        setIsModalOpen(false)
        setIsIframeOpen(false)
        loadConnectedProfile()
    }

    const profileName = connectedProfile
        ? `${connectedProfile.firstName || 'LinkedIn'} ${connectedProfile.lastName || 'Profile'}`.trim()
        : ''

    return (
        <StyledConnectLinkedIn>
            <CenterModal
                open={isModalOpen}
                setOpen={setIsModalOpen}
                noHead
                isCloseAble={false}
                padding='0'
                width={isIframeOpen ? 1439 : 1000}
                onClose={() => setIsIframeOpen(false)}
            >
                <ConnectAccountSteps
                    onClose={closeModal}
                    onIframeStateChange={setIsIframeOpen}
                    activeProfile={disconnectedProfile || undefined}
                    isLinkedinLogin={!!disconnectedProfile}
                />
            </CenterModal>

            <div className='intro-row'>
                <div className='img-holder'>
                    <img src={aiImg} alt='AI assistant' />
                </div>
                <div className='content'>
                    <span className='text'>
                        {connectedProfile
                            ? 'Your LinkedIn account is connected and ready to go.'
                            : 'Connect your LinkedIn account to activate your campaign.'}
                    </span>
                </div>
            </div>

            {connectedProfile ? (
                <div className='connect-card'>
                    <div className='card-icon'>
                        {connectedProfile.profile_photo ? (
                            <img src={connectedProfile.profile_photo} alt={profileName} />
                        ) : (
                            <FaLinkedinIn size={24} color='#fff' />
                        )}
                    </div>
                    <div className='card-body'>
                        <span className='card-title'>{profileName}</span>
                        <span className='connected-label'>
                            <FiCheck size={14} /> Connected
                        </span>
                    </div>
                </div>
            ) : (
                <div className='connect-card'>
                    <div className='card-icon'>
                        <FaLinkedinIn size={24} color='#fff' />
                    </div>
                    <div className='card-body'>
                        <span className='card-title'>Connect LinkedIn Profile</span>
                        <span className='card-subtitle'>
                            Allow Houdiny AI to send connection requests and messages on LinkedIn for your campaigns.
                        </span>
                    </div>
                    <button type='button' className='connect-btn' onClick={() => setIsModalOpen(true)}>
                        Connect
                    </button>
                </div>
            )}

            {!hasProceeded && (
                <button type='button' className='continue-btn' onClick={proceed}>
                    {connectedProfile ? 'Continue' : 'Connect LinkedIn account later'}
                </button>
            )}
        </StyledConnectLinkedIn>
    )
}

export default ConnectLinkedIn
